import React from "react";

export default function AccountPage() {
	return <div className='home_page'>

	</div>
}